import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { TweenMax } from 'gsap';
import { sectionMenu } from '../../../actions/section';

export class Menu extends React.Component {
	create() {
		let _this = this;

		$(window).on('resize.menu', function() {
			_this.animate();
        });

        this.animate();
	}
	animate() {
		let delay = 1,
			menu = $('#menu'),
			menuBaseW = 800,
			menuBaseH = 600,
			menuW = $('#menu').width(),
			menuH = $('#menu').height(),
			menuPercW = menuW / 100,
            menuPercH = menuH / 100,
			pippa = $('#pippa'),
			pippaParams = [346, 75, 157, 174], 
			eddie = $('#eddie'),
			eddieParams = [316, 181, 280, 284], 
			star = $('#star'),
			starParams = [218, 591, 209, 339], 
			ball = $('#ball'),
			ballParams = [190, 559, 72, 72];

		TweenMax.killAll();

		TweenMax.set(pippa, {
			top: menuPercH * ((pippaParams[0]/menuBaseH) * 100),
			left: menuPercW * ((pippaParams[1]/menuBaseW) * 100),
			width: menuPercW * ((pippaParams[2]/menuBaseW) * 100),
			height: menuPercH * ((pippaParams[3]/menuBaseH) * 100),
			alpha: 1
		});

		TweenMax.set(eddie, {
			top: menuPercH * ((eddieParams[0]/menuBaseH) * 100),
			left: menuPercW * ((eddieParams[1]/menuBaseW) * 100),
			width: menuPercW * ((eddieParams[2]/menuBaseW) * 100),
			height: menuPercH * ((eddieParams[3]/menuBaseH) * 100),
			scaleX: 1,
			alpha: 1
		});

		TweenMax.set(star, {
			top: menuPercH * ((starParams[0]/menuBaseH) * 100),
			left: menuPercW * ((starParams[1]/menuBaseW) * 100),
			width: menuPercW * ((starParams[2]/menuBaseW) * 100),
			height: menuPercH * ((starParams[3]/menuBaseH) * 100),
			alpha: 1
		});

		TweenMax.set(ball, {
			top: menuPercH * ((ballParams[0]/menuBaseH) * 100),
			left: menuPercW * ((ballParams[1]/menuBaseW) * 100),
			width: menuPercW * ((ballParams[2]/menuBaseW) * 100),
			height: menuPercH * ((ballParams[3]/menuBaseH) * 100),
			alpha: 1
		});

		TweenMax.from(pippa, 0.3, {left: 0, alpha: 0, delay: delay, ease: 'Circ.easeOut'});
		TweenMax.from(eddie, 0.2, {scaleX: 0.2, delay: delay, alpha: 0, ease: 'Bounce.easeOut'});
		TweenMax.from(star, 0.5, {top: menuH, delay: delay, ease: 'Back.easeOut'});
		TweenMax.from(ball, 0.5, {top: menuH * 0.6, left: menuW * 0.5, delay: delay, alpha: 0, ease: 'Back.easeOut'});
	}
	componentDidMount() {
		this.props.sectionMenu();
		this.create();
	}
    componentWillUnmount() {
        $(window).off('resize.menu');
    }
	render() {
        return (
			<div id="menu">
				<NavLink to="/before" activeClassName="is-active" exact={true}><div id="go-btn"></div></NavLink>
				<a id="wordlist-btn" href="http://www.oxfordwordlist.com" target="_blank"></a>
				<div id="title-handwriting"></div>
				<div id="start-btn-circle"></div>
				<div id="ball"></div>
				<div id="star"></div>
				<div id="eddie"></div>
				<div id="pippa"></div>
				<div id="logo"></div>
			    <div id="menu-bg"></div>
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionMenu: () => dispatch(sectionMenu())
});

export default connect(undefined, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/sections/menu/Menu.js